<template>
  <v-autocomplete :items="stationList" item-text="StationName" item-value="Id" label="Station" v-model="station" :rules="nullRule" return-object></v-autocomplete>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')

  export default {
    model: {
      prop: 'inputData',
      event: 'change',
    },
    props: {
      inputData: Object,
      database: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        station: {},
        nullRule: [
          (v) => {
            if (Object.values(v))
              return !Object.values(v).every(x => x.Id && x.StationName) || 'Is required, cannot be null'
            else
              return false
          },
        ],
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['NGStations', 'AQUARIUS_SERVER_NG']),
      stationList() {
        return this.database == this.AQUARIUS_SERVER_NG ? this.NGStations : []
      },
    },
    watch: {
      inputData() {
        this.station = this.inputData
      },
      station() {
        return this.$emit('change', this.station)
      },
    },
    methods: {},
    mounted() {
      this.station = this.inputData
    },
  }
</script>